import { RouteObject } from 'react-router-dom';
import { Agendas } from '../Agendas';
import { CreateAgenda } from '../pages';

const AgendaRoutes: RouteObject[] = [
  {
    path: 'agendas',
    element: <Agendas />,
  },
  {
    path: 'agendas/create',
    element: <CreateAgenda />,
  },
];

export default AgendaRoutes;
